<template>
  <div class="view-req-detail" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div>
          <ul class="relative">
            <!--            *****************************-->
            <li>
              <label>{{ $t('requestNameQ') }}</label>

              <span>
                  {{request_info.RequestName}}
              </span>
              <br>
              <span>
                  {{$route.params.rec_name}}
              </span>
            </li>
            <li>
              <label>{{ $t('requestStatusQ') }}</label>

              <span>
                {{request_info.LastStatus}}
              </span>
            </li>
            <!--            *****************************-->
            <li>
              <label>{{ $t('expertReceiptQ') }}</label>


              <span>
                {{request_info.ExpertName}}
              </span>
            </li>
            <li>
              <label>{{ $t('devicePasswordQ') }}</label>

              <span>
                {{request_info.DevicePass}}
              </span>
            </li>
            <li>
              <label>{{ $t('appearanceProblemQ') }}</label>

              <span>
                {{request_info.AppearanceProblem}}
              </span>
            </li>

            <li>
              <label>{{ $t('phoneNoQ') }}</label>


              <span>
                {{request_info.CustomerMobile}}
              </span>
            </li>

            <li>
              <label>{{ $t('ExpertOpinionQ') }}</label>

              <span>
                {{request_info.ExpertOpinion}}
              </span>
            </li>
            <li>
              <label>{{ $t('predefinedTagsQ') }}</label>

              <div class="text-right">
                <v-chip v-for="item in request_info.PredefinedGlobal"
                        class="ma-1"
                        color="primary"
                >
                  {{item.Text}}:{{item.Value}}
                </v-chip>

                <v-chip
                  v-for="item in request_info.PredefinedChecked"
                  class="ma-1"
                  color="primary"
                >
                  {{item.Text}}:{{item.Value}}

                </v-chip>
              </div>
            </li>
            <li>
              <label>{{ $t('referDescriptionQ') }}</label>


              <span>
               {{request_info.LastTechStatus}}
              </span>
            </li>
            <li>
              <label>{{ $t('descriptionQ') }}</label>

              <span>
               {{request_info.Summary}}
              </span>
            </li>
            <li>
              <label>{{ $t('priceRangeQ') }}</label>
              <span>
               {{request_info.TechPriceRange}}
              </span>
            </li>

            <li>
              <label>{{ $t('lastStatusQ') }}</label>

              <span>
               {{request_info.LastTechStatus}}
              </span>
            </li>
            <li>
              <label>{{ $t('summary') }}:</label>

              <span>
               {{request_info.Summary}}
              </span>
            </li>
            <li>
              <label>{{ $t('branchQ') }}</label>

              <span>
               {{request_info.BranchName}}
              </span>
            </li>
            <li>
              <label>{{ $t('requestType') }}</label>

              <span v-if="request_info.OnSiteService">{{ $t('inBranch') }}</span>
              <span v-else>{{ $t('inLocation') }}</span>

            </li>

          </ul>
          <v-row>

            <v-col cols="12" class="pa-1">
              <label>{{ $t('workFlow') }}</label>
              <div v-for="item in work_flows">
<hr>
                <div class="addresses">
                   <span>
                    {{item.TranTime}}
                  </span>
                  <br>
                  <span>
                    {{item.StatusName}}
                  </span>
                  <br>
                  <span>
                    {{item.ReceiverName}}
                  </span>
                  <br>

                  <span>
                    {{item.UserName}}
                  </span>
                  <br>

                  <span>
                    {{item.Summary}}
                  </span>
                </div>

              </div>

            </v-col>

          </v-row>

          <v-row>

            <v-col cols="12" class="pa-1">
              <label>{{ $t('addressesQ') }}</label>
              <div v-for="item in request_info.Addresses">
                <div class="addresses">
                  <span>
                    {{request_info.LastTechStatus}}
                  </span>
                </div>

              </div>

            </v-col>

          </v-row>

        </div>
        <div>
          <v-row>
            <v-col>
              <v-btn color="primary" v-if="action_button_text != ''" v-on:click="go_to_categories()">
                {{action_button_text}}
              </v-btn>
            </v-col>
          </v-row>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        request_info: [],
        action_button_text: '',
        request_statuses: [],
        next_action_status: 0,
        branch_id:0,
work_flows:[],
        technician_name: 'hamid mokhtari',
        device_password: 'hamid mokhtari',

      }
    },
watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
mounted () {
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      // this.get_device_status()
      // this.get_provinces()
      this.get_request_info()
      this.get_request_work_flow()
      this.get_branch_permission()
    },
    methods: {
      get_request_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          RequestId: this.$route.params.rec_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestInfoByReqId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.request_info = response.data.rec
              this.get_device_status()
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_request_work_flow () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          ReqId: this.$route.params.rec_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestStatusFlowById', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.work_flows = response.data.items
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      add_informher_master () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          RequestId: this.$route.params.rec_id,
          ReqName: this.request_info.RequestName,
          BranchId: this.branch_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddMasterFacator', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
this.get_informher_master()
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      go_to_categories () {
        var self = this
        if (this.$t('delivered').request_info.StatusId == self.request_statuses[2]) {
          self.action_button_text = self.$t('start_to_delivery')
          self.next_action_status = self.request_statuses[3]
        } else if (self.request_info.StatusId == self.request_statuses[3]) {
          self.action_button_text = self.$t('delivered')
          self.next_action_status = self.request_statuses[4]
        } else if (self.request_info.StatusId == self.request_statuses[4]) {
          self.action_button_text = ''
          self.next_action_status = 0
        } else if (self.request_info.StatusId == self.request_statuses[5]) {
          self.action_button_text = ''
          self.next_action_status = 0
        } else {
          self.action_button_text = ''
          self.next_action_status = 0
        }
        self.change_request_status(this.next_action_status)
      },
      go_to_goods_factors () {
        var self = this
        self.$router.push({ path: '/report-request/request-goods-factors/' + self.$route.params.rec_id })
      },
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt

            if (self.request_info.StatusId == self.request_statuses[2]) {
              self.action_button_text = self.$t('start_to_delivery')
              self.next_action_status = self.request_statuses[3]
            } else if (self.request_info.StatusId == self.request_statuses[3]) {
              self.action_button_text = self.$t('delivered')
              self.next_action_status = self.request_statuses[4]
            } else if (self.request_info.StatusId == self.request_statuses[4]) {
              self.action_button_text = ''
              self.next_action_status = 0
            } else if (self.request_info.StatusId == self.request_statuses[5]) {
              self.action_button_text = ''
              self.next_action_status = 0
            } else {
              self.action_button_text = ''
              self.next_action_status = 0
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_request_status (status_id) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          Desc: '',
          StatusId: status_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangeRequestStatus', send_data, {})
          .then(response => {
            self.get_request_info()
            if (status_id == self.request_statuses[4]) {
              // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
              self.$router.push({ name: 'signature', params: { rec_id: self.$route.params.rec_id, type_id: 5 } })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_branch_permission () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var party_id = localStorage.getItem('party_id')

        const send_data = {
          UserId: user_id,
          Role: 'BranchDefinition',
          PartyId: party_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ZkGetUserPermission', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.branch_id = response.data.UserBranchId
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
